export type User = {
  id: string
  preferences: string
  memo: string
  createdAt: Date
  updatedAt: Date
}

export const UserRole = {
  admin: 'admin',
  member: 'member',
  provisional: 'provisional',
  anonymous: 'anonymous'
} as const
export type UserRole = (typeof UserRole)[keyof typeof UserRole]

export function isWebSessionRole(role: UserRole): boolean {
  return role === UserRole.member || role === UserRole.provisional
}

export type UserDetail = User & {
  role: UserRole
  identities: Identity[]
}

export type Identity = {
  id: string
  userId: number
  service: IdentityService
  value: string
  createdAt: Date
  updatedAt: Date
}

export const IdentityService = {
  line: 'line',
  gp: 'gp',
  anonymous: 'anonymous'
} as const
export type IdentityService = keyof typeof IdentityService
